import React from 'react';
export function BenefitsSection() {
  return <section id="beneficios" className="py-20 w-full bg-white" aria-labelledby="beneficios-title" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        {/* Header */}
        <div className="text-center mb-14" data-id="element-3">
          <h2 id="beneficios-title" className="font-heading text-4xl sm:text-5xl font-bold text-navy-deep mb-4" data-id="element-4">
            ¿Por Qué Elegir el Mega Pack?
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto" data-id="element-5">
            Diseñado especialmente para la realidad del docente y catequista
            argentino.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-6">
          {/* Benefit 1 */}
          <div className="text-center px-4" data-id="element-7">
            <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-5 text-3xl" style={{
            backgroundColor: 'rgba(201, 168, 76, 0.12)'
          }} aria-hidden="true" data-id="element-8">
              ⏱️
            </div>
            <h3 className="font-heading text-xl font-bold text-navy-deep mb-3" data-id="element-9">
              Ahorro de Tiempo
            </h3>
            <p className="text-gray-500 text-sm leading-relaxed" data-id="element-10">
              No pierdas horas planificando. Tenés todo listo para aplicar
              directamente en el aula o en el salón parroquial.
            </p>
          </div>

          {/* Benefit 2 */}
          <div className="text-center px-4" data-id="element-11">
            <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-5 text-3xl" style={{
            backgroundColor: 'rgba(201, 168, 76, 0.12)'
          }} aria-hidden="true" data-id="element-12">
              📄
            </div>
            <h3 className="font-heading text-xl font-bold text-navy-deep mb-3" data-id="element-13">
              100% en PDF
            </h3>
            <p className="text-gray-500 text-sm leading-relaxed" data-id="element-14">
              Archivos PDF listos para descargar, guardar e imprimir. Sin
              internet después de la descarga.
            </p>
          </div>

          {/* Benefit 3 */}
          <div className="text-center px-4" data-id="element-15">
            <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-5 text-3xl" style={{
            backgroundColor: 'rgba(201, 168, 76, 0.12)'
          }} aria-hidden="true" data-id="element-16">
              📚
            </div>
            <h3 className="font-heading text-xl font-bold text-navy-deep mb-3" data-id="element-17">
              Diseño Curricular
            </h3>
            <p className="text-gray-500 text-sm leading-relaxed" data-id="element-18">
              Contenidos alineados al currículo argentino y al enfoque ERE
              Ver–Juzgar–Actuar del Episcopado.
            </p>
          </div>

          {/* Benefit 4 */}
          <div className="text-center px-4" data-id="element-19">
            <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-5 text-3xl" style={{
            backgroundColor: 'rgba(201, 168, 76, 0.12)'
          }} aria-hidden="true" data-id="element-20">
              ✝️
            </div>
            <h3 className="font-heading text-xl font-bold text-navy-deep mb-3" data-id="element-21">
              Versatilidad Total
            </h3>
            <p className="text-gray-500 text-sm leading-relaxed" data-id="element-22">
              Ideal tanto para colegios católicos como para catequesis
              parroquial, primaria y secundaria.
            </p>
          </div>
        </div>
      </div>
    </section>;
}